import { useEffect, useState } from 'react';

export default function InputSelect({
  label,
  inputId,
  placeholder,
  value = '',
  setValue,
  required = false,
  list,
  isValid,
  setIsValid = () => {},
  showErrors = false,
}) {
  const [validText, setValidText] = useState('');
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    // !isValid
    if (required && !value) {
      // console.log('value', value);
      return setValidText('항목을 선택해주세요.');
    }

    setValidText('');
  }, [required, isValid, value]);

  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-[minmax(160px,1fr)_minmax(0,3fr)_minmax(160px,1fr)] gap-2 md:gap-4 items-center mb-2">
      <label htmlFor={inputId} className="text-explorer font-semibold text-base">
        {label} <span className="text-giver align-middle">{required ? '*' : ''}</span>
      </label>
      <select
        id={inputId}
        className="min-w-0 w-full text-center rounded-lg bg-operator text-giver font-semibold"
        value={value}
        onBlur={() => setTouched(true)}
        onChange={(e) => {
          if (e.target.value) {
            setValue(e.target.value);
            setIsValid(true);
            return;
          }

          setValue(e.target.value);
          setIsValid(false);
        }}
      >
        <option key="default" value="">
          {placeholder}
        </option>
        {Object.keys(list).map((key) => (
          <option key={key} value={key}>
            {list[key]}
          </option>
        ))}
      </select>
      <div className="text-red-400 text-sm">{(touched || showErrors) && !isValid ? validText : ''}</div>
    </div>
  );
}
